import React from 'react'
import PropTypes from 'prop-types'

import { Card, List } from 'semantic-ui-react'
import { compose } from 'recompose'

import Container from './RugCardDetailedActionsContainer'

import CardProperty from 'Components/CardProperty'
import Permissions from 'Components/Permissions'

import { buildIsMasterpieceText, buildMFDText, buildRequestButton, buildRequestPopup } from './helpers'

const RugCardDetailedActions = props => {
  const {
    createRequest,
    deleteRequest,
    requestAsLink,
    rug,
    showCreateReservationModal,
    toggleIsMasterpiece,
    toggleMarkedForDesigners,
    user,
    userPermissions,
  } = props

  const activeRequest = rug.requests.find(r => !r.fulfilled && !r.deleted)

  const requestAction = (
    <CardProperty
      color={activeRequest ? 'yellow' : null}
      icon="feed"
      popUpContent={buildRequestPopup(activeRequest, user, userPermissions)}
    >
      {buildRequestButton(activeRequest, user, userPermissions)}
    </CardProperty>
  )

  return (
    <Permissions
      permissions={['rug.action.markForDesigners', 'rug.action.requestDesignerPicture', 'rug.action.reserve']}
      render={() => (
        <Card.Content extra>
          <List>
            <Permissions
              permissions="rug.action.isMasterpiece"
              render={() => (
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                <a onClick={toggleIsMasterpiece}>
                  <CardProperty
                    color={rug.isMasterpiece ? 'blue' : null}
                    icon="magic"
                    popUpContent={buildIsMasterpieceText(rug.isMasterpiece)}
                  >
                    {buildIsMasterpieceText(rug.isMasterpiece)}
                  </CardProperty>
                </a>
              )}
            />

            <Permissions
              permissions="rug.action.markForDesigners"
              render={() => (
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                <a onClick={toggleMarkedForDesigners}>
                  <CardProperty
                    color={rug.markedForDesigners ? 'yellow' : null}
                    icon="pin"
                    popUpContent={buildMFDText(rug.markedForDesigners)}
                  >
                    {buildMFDText(rug.markedForDesigners)}
                  </CardProperty>
                </a>
              )}
            />

            {requestAsLink ? (
              <Permissions
                permissions={['rug.action.requestDesignerPicture', 'rug.action.deleteRequestDesignerPicture']}
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                render={() => <a onClick={activeRequest ? deleteRequest : createRequest}>{requestAction}</a>}
              />
            ) : (
              <Permissions
                permissions={['rug.action.requestDesignerPicture', 'rug.action.deleteRequestDesignerPicture']}
                render={() => <div>{requestAction}</div>}
              />
            )}

            <Permissions
              permissions="rug.action.reserve"
              render={() => (
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                <a onClick={showCreateReservationModal}>
                  <CardProperty icon="bookmark" popUpContent="Reserve">
                    Reserve
                  </CardProperty>
                </a>
              )}
            />
          </List>
        </Card.Content>
      )}
    />
  )
}

RugCardDetailedActions.propTypes = {
  createRequest: PropTypes.func.isRequired,
  deleteRequest: PropTypes.func.isRequired,
  requestAsLink: PropTypes.bool.isRequired,
  rug: PropTypes.object.isRequired,
  showCreateReservationModal: PropTypes.func.isRequired,
  toggleMarkedForDesigners: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  userPermissions: PropTypes.array.isRequired,
}

const composed = compose(Container)

export default composed(RugCardDetailedActions)
